import { useMemo } from "react";

/**
 * Custom hook to extract and map a list of files from a documentList source.
 * Converts the documents into a simplified structure of { id, name }.
 * 
 * @param {Array|Object} documentList - The source document list (can be an array or an object containing a documents array).
 * @returns {Array} An array of objects containing id and name.
 */
export function useFiles(documentList) {
  return useMemo(() => {
    const docs = Array.isArray(documentList)
      ? documentList
      : (documentList?.documents || []);
    return docs.map((doc) => ({
      id: doc.id,
      name: doc.display_name || doc.name,
    }));
  }, [documentList]);
}
